// Components
import { SingleSelectListComponent } from 'SecurityListsApp/ts/features/security-list-selector-modals/components/single-select-list/single-select-list.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/pipes/index-of/index-of.pipe";
import * as i4 from "SecurityListsApp/ts/features/security-list-selector-modals/components/single-select-list/pipes/is-single-select-sub-list-item-selected.pipe";
const _c0 = a0 => ({ "bg-yc-blue-90": a0 });
const _c1 = a0 => ({ show: a0 });
const _c2 = a0 => ({ collapse: a0 });
function MultiLevelSingleSelectListComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function MultiLevelSingleSelectListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵlistener("click", function MultiLevelSingleSelectListComponent_div_0_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectItem(ctx_r1.parentItem, ctx_r1.parentItem)); });
    i0.ɵɵelementStart(2, "div", 4)(3, "span", 5);
    i0.ɵɵtext(4, "Select All");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, MultiLevelSingleSelectListComponent_div_0_div_5_Template, 3, 1, "div", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.parentItem && ctx_r1.parentItem.key === (ctx_r1.selectedItem == null ? null : ctx_r1.selectedItem.key) && ctx_r1.activeSecurityGroupTab === ctx_r1.selectedItemSecurityGroup);
} }
function MultiLevelSingleSelectListComponent_div_1_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function MultiLevelSingleSelectListComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function MultiLevelSingleSelectListComponent_div_1_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const item_r4 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectItem(item_r4, ctx_r1.parentItem)); });
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelement(2, "span", 15);
    i0.ɵɵtemplate(3, MultiLevelSingleSelectListComponent_div_1_div_1_div_3_Template, 3, 1, "div", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", item_r4.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", item_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.key === (ctx_r1.selectedItem == null ? null : ctx_r1.selectedItem.key) && ctx_r1.activeSecurityGroupTab === ctx_r1.selectedItemSecurityGroup);
} }
function MultiLevelSingleSelectListComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵpipe(1, "isSingleSelectSubListItemSelected");
    i0.ɵɵlistener("click", function MultiLevelSingleSelectListComponent_div_1_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const item_r4 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openItem(item_r4)); });
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵelement(3, "div", 18);
    i0.ɵɵpipe(4, "indexOf");
    i0.ɵɵelementStart(5, "span", 19);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c0, i0.ɵɵpipeBind4(1, 3, item_r4, ctx_r1.selectedItem, ctx_r1.selectedItemSecurityGroup, ctx_r1.activeSecurityGroupTab)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c1, i0.ɵɵpipeBind2(4, 8, ctx_r1.openListItems, item_r4) > -1));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r4.name);
} }
function MultiLevelSingleSelectListComponent_div_1_ycn_multi_level_single_select_list_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-multi-level-single-select-list", 20);
    i0.ɵɵpipe(1, "indexOf");
    i0.ɵɵlistener("selectItemHandler", function MultiLevelSingleSelectListComponent_div_1_ycn_multi_level_single_select_list_3_Template_ycn_multi_level_single_select_list_selectItemHandler_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectItem($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("level-", (ctx_r1.level + 1).toString(), "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2, i0.ɵɵpipeBind2(1, 10, ctx_r1.openListItems, item_r4) === -1))("parentItem", item_r4)("listItems", item_r4.sub_list)("selectedItem", ctx_r1.selectedItem)("selectedItemSecurityGroup", ctx_r1.selectedItemSecurityGroup)("activeSecurityGroupTab", ctx_r1.activeSecurityGroupTab)("level", ctx_r1.level + 1);
} }
function MultiLevelSingleSelectListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MultiLevelSingleSelectListComponent_div_1_div_1_Template, 4, 3, "div", 10)(2, MultiLevelSingleSelectListComponent_div_1_div_2_Template, 7, 15, "div", 11)(3, MultiLevelSingleSelectListComponent_div_1_ycn_multi_level_single_select_list_3_Template, 2, 15, "ycn-multi-level-single-select-list", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r4.sub_list);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.sub_list);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.sub_list && item_r4.sub_list.length > 0);
} }
export class MultiLevelSingleSelectListComponent extends SingleSelectListComponent {
    constructor() {
        super(...arguments);
        this.parentItem = null;
        this.level = 0;
    }
}
MultiLevelSingleSelectListComponent.ɵfac = /*@__PURE__*/ (() => { let ɵMultiLevelSingleSelectListComponent_BaseFactory; return function MultiLevelSingleSelectListComponent_Factory(t) { return (ɵMultiLevelSingleSelectListComponent_BaseFactory || (ɵMultiLevelSingleSelectListComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MultiLevelSingleSelectListComponent)))(t || MultiLevelSingleSelectListComponent); }; })();
MultiLevelSingleSelectListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiLevelSingleSelectListComponent, selectors: [["ycn-multi-level-single-select-list"]], inputs: { parentItem: "parentItem", level: "level" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "linked-list-item", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "linked-list-item"], [1, "linked-list-item-header", "file-td-name", "td", 3, "click"], [1, "linked-list-item-header-wrap"], [1, "file-title"], ["class", "linked-list-item-controls", 4, "ngIf"], [1, "linked-list-item-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-check"], ["ycnIcon", "", 3, "name"], ["class", "linked-list-item parent border-bottom-0", 3, "click", 4, "ngIf"], ["class", "linked-list-collapse file-td-name border-bottom-0 td", 3, "ngClass", "click", 4, "ngIf"], [3, "class", "ngClass", "parentItem", "listItems", "selectedItem", "selectedItemSecurityGroup", "activeSecurityGroupTab", "level", "selectItemHandler", 4, "ngIf"], [1, "linked-list-item", "parent", "border-bottom-0", 3, "click"], [1, "file-td-name", "linked-list-item-header", "td", 3, "id"], [1, "text-gray-10", 3, "textContent"], [1, "linked-list-collapse", "file-td-name", "border-bottom-0", "td", 3, "click", "ngClass"], [1, "file-name"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "collapse-toggler", 3, "ngClass"], [1, "text-normal"], [3, "selectItemHandler", "ngClass", "parentItem", "listItems", "selectedItem", "selectedItemSecurityGroup", "activeSecurityGroupTab", "level"]], template: function MultiLevelSingleSelectListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MultiLevelSingleSelectListComponent_div_0_Template, 6, 1, "div", 0)(1, MultiLevelSingleSelectListComponent_div_1_Template, 4, 3, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.level > 0 && ctx.parentItem && ctx.parentItem.key);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.listItems);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.IconDirective, MultiLevelSingleSelectListComponent, i3.IndexOfPipe, i4.isSingleSelectSubListItemSelectedPipe], encapsulation: 2 });
